import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=8f47e894&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"
import style0 from "./nav.vue?vue&type=style&index=0&id=8f47e894&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f47e894",
  null
  
)

export default component.exports